import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { BRUSSELS_TIMEZONE } from "@/constants/timezone.constants";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Current time in Brussels timezone */
export function brusselsNow() {
	return dayjs().tz(BRUSSELS_TIMEZONE);
}

/** Parse a date in Brussels timezone. Returns null for falsy input. */
export function brusselsDayjs(date: string | Date | number | null | undefined) {
	if (!date) return null;
	return dayjs(date).tz(BRUSSELS_TIMEZONE);
}
